// import { useEffect } from 'react';

function DetectTabChange() {
  // useEffect(() => {
  //   const handleVisibilityChange = () => {
  //     if (document.hidden) {
  //       // eslint-disable-next-line no-console
  //       console.log('User switched tabs or minimized the window.');
  //     } else {
  //        // eslint-disable-next-line no-console
  //       console.log('User switched back to the tab or maximized the window.');
  //     }
  //   };

  //   document.addEventListener('visibilitychange', handleVisibilityChange);

  //   return () => {
  //     document.removeEventListener('visibilitychange', handleVisibilityChange);
  //   };
  // }, []);
}

export default DetectTabChange;
